
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import norveg from "../../assets/norveg.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function NorvegMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Norvég magyar fordító</title>
                <meta name='description' content="Ingyenes norvég magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Norvég magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/norveg-magyar-fordito" />
            </Helmet>
            <h1>Norvég magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A Norvég nyelvről</h2>
                    <img src={norveg} alt="Norvég zászló"></img>
                </div>

                <p>A norvég egy észak-német nyelv, amelyet Norvégiában körülbelül 5 millió ember beszél. Szoros rokonságban áll más skandináv nyelvekkel, például a dánnal és a svéddel, és különböző mértékben érthető egymással. A norvég nyelv Norvégia hivatalos nyelve, és két hivatalos írásmóddal rendelkezik: Bokmål és Nynorsk.</p>

                <p>A bokmål, ami "könyvnyelvet" jelent, a norvég nyelv legszélesebb körben használt írásmódja. A dán befolyású norvég nyelvre épül, és a kormányzat, az oktatás és a média szabványa. A nynorsk, azaz az "új norvég" egy újabb írásmód, amely a vidéki nyelvjárásokon alapul, és célja, hogy tükrözze Norvégia nyelvi sokszínűségét.</p>

                <p>Írásrendszere a latin ábécét használja, néhány további betűvel és diakritikus jelekkel kiegészítve. 29 betűből áll, köztük az æ, ø és å betűkből. A norvég kiejtés regionálisan eltérő, de összességében fonetikus, és a helyesírás és a hangzás között egyértelmű a megfelelés.</p>

                <p>A norvég nyelvtan hasonlóságokat mutat más skandináv nyelvekkel. Három nyelvtani neme van (hímnemű, nőnemű és semleges), és megmaradt a főnévfajták és igekötők összetett rendszere. Más skandináv nyelvekhez képest azonban a norvég nyelvtan viszonylag egyszerűbb.</p>

                <p>A norvég szókincsnek germán gyökerei és más nyelvekből, különösen az angolból származó kölcsönszavak egyaránt vannak. A norvég nyelv arról ismert, hogy szívesen vesz át új szavakat idegen nyelvekből, különösen a technológia és a populáris kultúra területén.</p>

                <p>A norvég kultúra szorosan összefonódik a nyelvvel. Norvégia gazdag irodalmi örökséggel rendelkezik, olyan híres írókkal, mint Henrik Ibsen és Knut Hamsun. A norvég folklór, a hagyományos zene és az olyan szabadtéri tevékenységek, mint a síelés és a túrázás, a norvég identitás fontos elemei.</p>

                <p>A norvég nyelv ismerete ajtókat nyithat meg a norvégiai lehetőségekhez, beleértve az oktatást, a munkát és a kulturális elmélyülést. Norvégia gazdasága erős, különösen az olyan ágazatokban, mint az olaj- és gázipar, a megújuló energiaforrások és a tengerészeti ipar. A norvég nyelv ismerete előnyös lehet az ezeken a területeken való elhelyezkedés vagy a norvég egyetemeken való tanulás szempontjából.</p>

                <p>A norvég nyelv a többi skandináv nyelv megértéséhez is kaput jelent. A norvég, a dán és a svéd nyelv közötti hasonlóságok lehetővé teszik a tanulók számára, hogy szélesebb skandináv kontextusban kommunikáljanak és tájékozódjanak.</p>
          
                <div className="sectionbottom">
                    <Link to="/magyar-norveg-fordito">Magyar norvég fordító</Link>

                    <img src={norveg} alt="norvég zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
          
          
            </section>
        </>

    )
}

export default NorvegMagyar;